// Minimal changes for Vite compatibility

import { QueryClient, QueryClientProvider as QueryClientProviderLib } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { AxiosError } from 'axios'
import { useState } from 'react'
import type { ReactNode } from 'react'

const MAX_RETRIES = 3
const HTTP_STATUS_TO_NOT_RETRY = [400, 401, 403, 404]

type QueryClientProviderProps = {
  children: ReactNode
}

function QueryClientProvider({ children }: QueryClientProviderProps) {
  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        queries: {
          retry: (failureCount, err) => {
            const error = err as AxiosError
            if (failureCount > MAX_RETRIES) {
              return false
            }

            if (HTTP_STATUS_TO_NOT_RETRY.includes(error?.response?.status ?? 0)) {
              return false
            }

            return true
          },
          refetchOnWindowFocus: false,
        },
      },
    }),
  )
  return (
    <QueryClientProviderLib client={client}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProviderLib>
  )
}

export default QueryClientProvider
